import { Button, Checkbox, DatePicker, Form, Radio, Select, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { filterOption, requiredField } from "../common/common";
import { UploadOutlined } from "@ant-design/icons";
import axiosInstance from "../common/api";
import { useNavigate, useParams } from "react-router";
import Dragger from "antd/lib/upload/Dragger";
import FormPage from "../common/FormPage";
import dayjs from "dayjs";
import { outcomes } from "./MedicalVisits";
import { useForm } from "antd/lib/form/Form";

export default function () {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [dataLoading, setDataLoading] = useState(false);
  const { id } = useParams();
  const [form] = useForm();
  const changeFileWatch = Form.useWatch("changeFile", form);

  useEffect(() => {
    setDataLoading(true);
    axiosInstance
      .get(`medicalVisit/${id}`)
      .then(({ data }) => {
        setData(data.medicalFitness);
        form.setFieldsValue(data.medicalFitness);
      })
      .finally(() => setDataLoading(false));
  }, []);

  const onFormFinish = (form) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("outcome", form.outcome);
    formData.append("date", form.date);
    formData.append("dueDate", form.dueDate);
    if (form.changeFile) formData.append("file", form.file.file);
    axiosInstance
      .put(`/medicalFitness/${data.id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };
  return (
    <FormPage
      form={form}
      title={"Modifica giudizio di idoneità"}
      onFinish={onFormFinish}
      initialValues={{ changeFile: false }}
    >
      <Skeleton loading={dataLoading} active>
        <Form.Item name="outcome" label="Giudizio espresso" rules={[requiredField]}>
          <Select
            filterOption={filterOption}
            showSearch
            placeholder={"Giudizio espresso"}
            options={Object.entries(outcomes).map(([key, value]) => ({ label: value, value: key }))}
          />
        </Form.Item>
        <Form.Item
          label="Data"
          rules={[requiredField]}
          name="date"
          getValueProps={(value) => ({ value: value && dayjs(value) })}
          normalize={(value) => value && value.format("YYYY-MM-DD")}
        >
          <DatePicker />
        </Form.Item>

        <Form.Item
          label="Data scadenza"
          rules={[requiredField]}
          name="dueDate"
          getValueProps={(value) => ({ value: value && dayjs(value) })}
          normalize={(value) => value && value.format("YYYY-MM-DD")}
        >
          <DatePicker />
        </Form.Item>

        <Form.Item  name="changeFile" valuePropName={"checked"} rules={[requiredField]}>
          <Checkbox>Sostituisci documento</Checkbox>
        </Form.Item>

        {changeFileWatch && (
          <Form.Item label={"File"} name="file" valuePropName={"file"} rules={[requiredField]}>
            <Dragger accept={"application/pdf"} maxCount={1} beforeUpload={() => false}>
              <p>Trascina qui il file (Solo .pdf accettati)</p>
              <Button icon={<UploadOutlined />}>Seleziona file</Button>
            </Dragger>
          </Form.Item>
        )}

        <Form.Item wrapperCol={{ span: 24 }} style={{ textAlign: "end" }}>
          <Button htmlType={"submit"} type={"primary"} loading={loading}>
            Salva
          </Button>
        </Form.Item>
      </Skeleton>
    </FormPage>
  );
}
